/**
 * @flow
 * @relayHash e07882b61b9809c1641ba1a56f51b240
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MessageBannerRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "fetchMarketingMessagesTransactions",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserType",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "setId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String!]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userType",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageBannerRefetchQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MessageBanner_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "hasUserType",
                "variableName": "hasUserType",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "setId",
                "variableName": "setId",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "userType",
                "variableName": "userType",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": "dibs-buyer-layout/173.2.1-2018-06-20T22:36:00.464Z/MessageBannerRefetchQuery",
  "kind": "Batch",
  "metadata": {},
  "name": "MessageBannerRefetchQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "fetchMarketingMessagesTransactions",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserType",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "setId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String!]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userType",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "MessageBannerRefetchQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchMarketingMessagesTransactions",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "allTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "initiatedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.initiated",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "createdDate asc",
                    "type": "String"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.confirmed",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserType",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "messages",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "setId",
                    "variableName": "setId",
                    "type": "String"
                  },
                  {
                    "kind": "Variable",
                    "name": "userType",
                    "variableName": "userType",
                    "type": "String!"
                  }
                ],
                "concreteType": "MessageSetModule",
                "name": "messageSet",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageSetItem",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "impressionCap",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "MarketingMessage",
                        "name": "note",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "MarketingMessageContent",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "message",
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "MarketingMessageCta",
                                "name": "cta",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "text",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "MarketingMessage",
                            "name": "anchors",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "MarketingMessage",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "serviceId",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MarketingMessageContent",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "args": null,
                                        "name": "title",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "args": null,
                                        "name": "message",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MarketingMessageCta",
                                        "name": "cta",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "text",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "url",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
